import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import OwnerOverview from './OwnerOverview';
import OwnerBusinesses from './OwnerBusinesses';
import OwnerBusinessDetail from './OwnerBusinessDetail';
import OwnerAddBusiness from './OwnerAddBusiness';
import OwnerEnquiries from './OwnerEnquiries';
import OwnerVisits from './OwnerVisits';
import OwnerBoost from './OwnerBoost';
import OwnerPayments from './OwnerPayments';
import Profile from '../Profile';

const LINKS = [
  { to: '/owner', end:true, label: 'Overview',       testid: 'owner-overview' },
  { to: '/owner/businesses', label: 'My businesses', testid: 'owner-businesses' },
  { to: '/owner/add',       label: 'Add business',   testid: 'owner-add' },
  { to: '/owner/enquiries', label: 'Enquiries',      testid: 'owner-enquiries' },
  { to: '/owner/visits',    label: 'Employee visits', testid: 'owner-visits' },
  { to: '/owner/boost',     label: 'Boost my business', testid: 'owner-boost' },
  { to: '/owner/payments',  label: 'Payments',       testid: 'owner-payments' },
  { to: '/owner/profile',   label: 'Profile',        testid: 'owner-profile' },
];

export default function OwnerLayout() {
  return (
    <div className="ap-shell" data-testid="owner-shell">
      <Sidebar title="Business owner" links={LINKS} />
      <main className="ap-content">
        <Routes>
          <Route index element={<OwnerOverview />} />
          <Route path="businesses" element={<OwnerBusinesses />} />
          <Route path="businesses/:id" element={<OwnerBusinessDetail />} />
          <Route path="add" element={<OwnerAddBusiness />} />
          <Route path="enquiries" element={<OwnerEnquiries />} />
          <Route path="visits" element={<OwnerVisits />} />
          <Route path="boost" element={<OwnerBoost />} />
          <Route path="payments" element={<OwnerPayments />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/owner" replace />} />
        </Routes>
      </main>
    </div>
  );
}
